import { LocationRegisterType } from '../types/location-register';

export let LocationRegisterList: LocationRegisterType[] = [
    {
        id: 1,
        name: 'Registers',
        title: 'Number of Register',
        price: 49,
        quantity: 1,
        withTaxPrice: 0,
        defaultRegister: 1,
        defaultLocation: 1,
        selected: false,
        // Same Stripe product ids signup-v5/checkout.component.ts already uses for this line item.
        StripeProductKey: 'prod_SL8Y9nGEXRYUBG',
        StripeSandboxProductKey: 'prod_SGyCEUkTtMAMN3',
    },
    {
        id: 2,
        name: 'Locations',
        title: 'Number of Location',
        price: 79,
        quantity: 1,
        withTaxPrice: 0,
        defaultRegister: 1,
        defaultLocation: 1,
        selected: false,
        StripeProductKey: 'prod_SL8Ylp40XVnLv4',
        StripeSandboxProductKey: 'prod_SGyCcFYZlU5kWS',
    },
];
